"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GA", {
    enumerable: true,
    get: function() {
        return GA;
    }
});
var _loadGA = require("./loadGA");
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var GA = function GA(config) {
    "use strict";
    _class_call_check(this, GA);
    _define_property(this, "identify", function(userId) {
        window.ga('set', 'userId', userId);
        window.ga('send', 'event', 'authentication', 'user-id available');
    });
    // Not supported
    _define_property(this, "group", function() {});
    _define_property(this, "page", function(pageName) {
        var traits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        window.ga('send', {
            hitType: 'pageview',
            page: traits.path || location.pathname,
            title: pageName
        });
    });
    _define_property(this, "track", function(eventName) {
        var traits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        window.ga('send', {
            hitType: 'event',
            eventCategory: traits.category || 'None',
            eventAction: eventName
        });
    });
    // Not supported
    _define_property(this, "reset", function() {});
    _define_property(this, "revenue", function() {});
    if (!config.trackingId) {
        throw new Error('Google Analytics trackingId is required for analytics');
    }
    var ga = (0, _loadGA.loadGA)();
    ga('create', config.trackingId, config.cookieDomain || 'auto');
};
